import React from 'react';
import { List } from '@mui/material';
import { ProviderDocument } from '@uplift/api';
import { DocumentListItem } from './DocumentListItem';


export const DocumentsList: React.FC<{
  documents: ProviderDocument[];
  selectedDocumentId?: string;
  onSelectDocument: (doc: string) => void;
}> = ({ documents, selectedDocumentId, onSelectDocument }) => {
  return (
    <List disablePadding>
      {documents.map(document => {
        const selected = selectedDocumentId === document.id;

        return (
          <DocumentListItem
            key={document.id}
            document={document}
            onClick={() => onSelectDocument(document.id)}
            selected={selected}
          />
        );
      })}
    </List>
  );
};
